<template>
  <div>
    <!--Loading-->
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

    <PageTitle title="Grade" />
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <div class="card-content">
            <b-field>
              <b-button @click="addNewGrade()" type="is-info">Create a new grade</b-button>
            </b-field>

            <!--Set Grade-->
            <b-modal :active.sync="modalGradeActive"
            has-modal-card
            trap-focus
            :destroy-on-hide="true"
            aria-role="dialog"
            aria-modal>
              <set-grade :grade_id="edit_grade_id" @over="modalGradeActive = false"></set-grade>
            </b-modal>

            <b-table :paginated="true" :per-page="20" :pagination-simple="true" :data="fetchGrades">
              <b-table-column v-slot="props" field="name" label="Name">{{props.row.name}}</b-table-column>
              <b-table-column v-slot="props" field="order" label="Order" sortable>{{props.row.order}}</b-table-column>
              <b-table-column v-slot="props" field="description" label="Description">{{props.row.description}}</b-table-column>
              <b-table-column v-slot="props" field="remarks" label="Remarks">{{props.row.remarks}}</b-table-column>
              <b-table-column v-slot="props" field="status" label="Status">
                <b-tag :type="props.row.status ? 'is-success' : 'is-danger'">
                  {{ props.row.status ? 'Active' : 'Inactive' }}
                </b-tag>
              </b-table-column>
              <b-table-column v-slot="props" field="created_at" label="Created At">{{$common.formatDate(props.row.created_at)}}</b-table-column>
              <b-table-column v-slot="props" field="actions" label="Action">
                <div class="buttons">
                  <b-button @click="editGrade(props.row._id)" type="is-primary" size="is-small" icon-left="pencil"></b-button>
                  <b-button @click="deleteThisGrade(props.row._id)" type="is-danger" size="is-small" icon-left="delete"></b-button>
                </div>
              </b-table-column>
              <template slot="empty">
                <empty-table message="No grades created."></empty-table>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Vuex
import {mapGetters, mapActions} from 'vuex'
import PageTitle from '@/components/PageTitle'
import EmptyTable from '@/components/EmptyTable'
import SetGrade from '@/components/Grade/SetGrade'

export default {
  name : 'Candidate',
  components : {
    PageTitle, EmptyTable, SetGrade
  },
  data(){
    return {
      isLoading : false,
      modalGradeActive : false,
      edit_grade_id : null
    }
  },
  computed : {
    ...mapGetters(['fetchGrades', 'getTeacherToken'])
  },
  methods : {
    ...mapActions(['loadGrades', 'deleteGrade']),
    addNewGrade(){
      this.modalGradeActive = true
    },
    editGrade(id){
      this.modalGradeActive = true
      this.edit_grade_id = id
    },
    deleteThisGrade(id){
      this.$buefy.dialog.confirm({
        title: 'Continue deleting this grade',
        message : 'Are you sure want to delete this grade permanently?',
        type : 'is-danger',
        onConfirm: () => {
          this.deleteGrade({
            token : this.getTeacherToken,
            grade : id
          }).then(() => {
            this.$buefy.toast.open({
              message: 'Grade deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    }
  },
  async created(){
    this.isLoading = true
    try{
      await this.loadGrades({ token : this.getTeacherToken })
    }catch(err){
      this.$buefy.toast.open({
        message: err.response.data,
        type: 'is-danger'
      })
    }
    this.isLoading = false
  }
  
}
</script>